<template>
  <div class="container flex" v-if="isShowLight">
    <div id="test" class="flex ml10" v-show="!(modeType == 3)" v-if="!isShow">
      <div class="leftNav mt10 flex1">
        <div style="width: 98%">
          <el-input placeholder="请输入名称查询" clearable v-model="company" @blur="searchcomp" prefix-icon="el-icon-search"></el-input>
        </div>
        <div style="height: 92%; overflow: auto">
          <el-menu default-active="1-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
            <el-submenu :index="String(index + 1)" v-for="(item, index) in companyList1.length ? companyList1 : companyList" :key="index">
              <template slot="title">
                <i :class="'el-icon-folder' || 'el-icon-folder-opened'"></i>
                <span>{{ item.company }}</span>
              </template>
              <el-menu-item @click="checkCop(it)" :index="`${String(index + 1)}-${String(ind + 1)}`" v-for="(it, ind) in item.data" :key="ind">
                <i class="el-icon-document"></i>
                {{ it.area_name }}
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="content flex1">
        <div
          class="canvas"
          ref="can1"
          :style="{
            transform: 'scale(' + num + ')',
            position: 'relative',
            height: '100%',
            width: '100%',
          }"
          @mousewheel="suo"
          @mousedown.stop="moveMouse"
          v-if="dwImg"
        >
          <crtmarker ref="lightingPanelEditor" :isBZ="true" @added="added" :imgUrl="dwImg" :iconId="iconId" />
        </div>
      </div>
      <div class="rightnav mt10" style="width: 25%; height: 91%">
        <div style="width: 100%" class="center">
          <el-col :span="24">
            <el-col :span="6">
              <el-button type="primary" class="ml10" size="small" @click="downloadstair()"> 下载模板</el-button>
            </el-col>
            <el-col :span="6">
              <el-upload
                ref="upload"
                :limit="1"
                accept=".xlsx, .xls"
                :headers="upload.headers"
                :data="{ areaUuid: rightParams.area_uuid }"
                :action="upload.url + '?updateSupport=' + upload.updateSupport"
                :on-progress="handleFileUploadProgress"
                :on-success="handleFileSuccess"
                :auto-upload="true"
              >
                <el-button type="success" class="ml10" size="small" v-hasPermi="['device:fireDoorDevice:import']">上传文件</el-button>
              </el-upload>
            </el-col>
            <el-input
              style="margin-top: 20px;"
              placeholder="请输入部位号或名称查询"
              clearable
              prefix-icon="el-icon-search"
              v-model="rightParams.true_addr"
              @clear="reset"
            ></el-input>
          </el-col>
          <el-col :span="5">
            <el-button type="primary" class="ml10" style="margin-top: 50px" size="small" @click="searchRight">查询</el-button>
          </el-col>
          <el-col :span="5">
            <el-button class="ml10" style="margin-top: 50px" size="small" @click="reset">重置</el-button>
          </el-col>
        </div>
        <div v-if="tableType == 0">
          <div style="width: 100%; height: 90%; overflow: auto">
            <el-table :data="qvyuList" class="mt10" style="">
              <el-table-column prop="true_addr" label="设备名称" align="center">
                <template slot-scope="scope">
                  <!-- @click="changeRightMode(scope.row)" -->
                  <div class="cursor">
                    {{ scope.row.true_addr }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="true_addr" label="位置" align="center">
                <template slot-scope="scope">
                  <div :class="stateColor(scope.row.state)" style="position: relative;width: 90px;height: 60px;transform: translate(17px, 0);color: rgb(0, 0, 0);">
                    <span
                      style="position: absolute;top: 16px;right: 58px;cursor: pointer;"
                      :class="'btn-time el-icon-back' + (isPoint(scope.row.arrow_remark, 3) ? (scope.row.state ? ' start show-test' : ' show-test') : '')"
                      @click="selectPositon($event, scope.row, 3)"
                    ></span>
                    <span
                      style="position: absolute;left: 53px;top: 16px;cursor: pointer;"
                      :class="'btn-time el-icon-right' + (isPoint(scope.row.arrow_remark, 4) ? (scope.row.state ? ' start show-test' : ' show-test') : '')"
                      @click="selectPositon($event, scope.row, 4)"
                    ></span>
                    <span
                      style="position: absolute;top: -1px ;left:29px;cursor: pointer;"
                      :class="'btn-time el-icon-top' + (isPoint(scope.row.arrow_remark, 1) ? (scope.row.state ? ' start show-test' : ' show-test') : '')"
                      @click="selectPositon($event, scope.row, 1)"
                    ></span>
                    <span
                      style="position: absolute;top: 35px; left:29px;cursor: pointer;"
                      :class="'btn-time el-icon-bottom' + (isPoint(scope.row.arrow_remark, 2) ? (scope.row.state ? ' start show-test' : ' show-test') : '')"
                      @click="selectPositon($event, scope.row, 2)"
                    ></span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" :type="scope.row.isMark ? 'warning' : 'primary'" icon="el-icon-edit" @click="markp(scope.row, scope.$index)"></el-button>

                  <el-popconfirm title="确定删除此点位吗？" class="cursor" @confirm="cancle(scope.row)" @onConfirm="cancle(scope.row)">
                    <a slot="reference" class="red">
                      <el-button type="danger" icon="el-icon-delete" size="mini"></el-button>
                    </a>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination background v-if="rightNum > 9" layout="prev, pager, next" :page-size="rightParams.limit || 9" @current-change="pageChange" :total="rightNum">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crtmarker from '../../components/crtmarker';
import { mapState } from 'vuex';

import { getMapByid } from '../../api/common';
import config from '../../utils/config.js';
if (process.env.NODE_ENV == 'development') {
  //本地
  var wsUrl = config.wsUrltest;
} else if (process.env.NODE_ENV == 'production') {
  //线上
  var wsUrl = config.wsUrl;
}

export default {
  components: {
    crtmarker,
  },
  props: ['nowDevice', 'isShow', 'it'],
  computed: {
    ...mapState(['otherBjList']),
  },
  data() {
    return {
      num: 1,
      isdraged: true,
      add: false, //是否新增变化
      typeList: [], // 点位类型
      company: '', // 当前查询的公司
      companyList: [], //公司列表
      upload: {
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: 'Bearer ' + this.$local.get('token') },
        // 上传的地址
        url: this.$config.apiUrl + '/crtarea/importLight',
        areaUuid: '',
      },
      companyList1: [], //查询到的公司列表
      qvyuList: [], //区域列表
      pointList: [], //点位列表
      modeType: 1, // 1：平面图 3：全图列表
      tableType: 0, //0:点位列表 1:当前楼梯列表
      videoList: [], // 摄像头列表
      selectPoint: {}, // 选中的点位
      selectcomp: '',
      loading: false,
      detailList: [], // 全部列表的表头
      detaillist: [], // 全部大列表详情列表实际数据
      detailData: [],

      tableData: [], //  大列表接口返回的数据
      tableList: [], //代存的数据 单个数据
      tablelist: [], // 平面图模式列表渲染数据
      rightParams: {
        area_uuid: '',
        number: '',
        point_type: 280,
        true_addr: '',
        page: 1,
      },
      // 右侧楼梯列表uuid params
      stairparams: {
        areaUUid: '',
        stairDeviceNo: '',
      },
      rightNum: 9,
      warning: false,
      nowMessage: {},
      videoAddr: '',
      curObj: {}, // 当前查看的设备
      form: {}, //最终确定的点位
      dwImg: '',
      radio1: '',

      isChecked: 0,
      beforeTarget: {}, //记录上次点击的按钮
      selectPositonLoading: false, // 方向按钮点击
      listarea: {
        type: '',
        wsType: 1,
      },
      list: [],
      iconId: '',
      isShowLight: false,
    };
  },
  watch: {
    otherBjList(it) {
      if (it[0].areaUuid == this.rightParams.area_uuid) {
        this.nowMessage = it[0];
        // this.getBigList();
        if (this.stairparams.stairDeviceNo == it[0].stairDeviceNo) {
          this.getRightStairList();
        }
      }
    },

    nowDevice(val) {
      if (this.curObj && val && val.deviceType == 243) {
        if (this.curObj.areaUUid == this.rightParams.area_uuid) {
          var obj = { ...this.curObj, ...val };
          this.curObj = obj;
          // this.getBigList();
          if (obj.staireId === this.stairparams.stairDeviceNo) {
            this.getRightStairList();
          }
        }
      }
    },
  },
  created() {
    getMapByid(176).then((res) => {
      this.typeList = res.data;
    });

    // 获取单位
    this.$post('/crt/crtmenu', { type: 2 }).then((res) => {
      if (res.data.length) {
        this.isShowLight = true;
        this.companyList = res.data;
        for (var i = 0; i < this.companyList.length; i++) {
          if (this.companyList[i].data.length) {
            this.checkCop(this.companyList[i].data[0]);
            break;
          }
        }
      } else {
        this.isShowLight = false;
        this.$message.warning('该业务尚未开通，请联系管理员');
      }
    });
    this.initWebSocket();
  },
  destroyed() {
    this.websock.close(); //离开路由之后断开websocket连接
  },
  methods: {
    stateColor(value) {
      switch (value) {
        case 1:
          return 'light';
        case 2:
          return '';
        case 3:
          return 'yellow';
        default:
          return 'gray';
      }
    },
    isPoint(data, index) {
      if (!data || !data.length) return false;
      return data?.some((item) => item == index);
    },
    initWebSocket() {
      //初始化weosocket
      // const wsuri = "ws://47.105.170.47:8888/ws/mqt";
      let wsUrl = '';
      if (process.env.NODE_ENV == 'development') {
        //本地
        wsUrl = config.wsUrltest;
      } else if (process.env.NODE_ENV == 'production') {
        //线上
        wsUrl = config.wsUrl;
      }
      this.websock = new WebSocket(wsUrl);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      log('链接');
      //连接建立之后执行send方法发送数据
      let message = 'fasong';
      this.websocketsend(JSON.stringify(message));
    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) {
      //数据接收
      const redata = JSON.parse(e.data);
      for (const iterator of redata) {
        if (iterator.type == '270' && iterator.wsType == 1) {
          for (const item of this.list) {
            if (item.device_name == iterator.deviceNo) {
              item = Object.assign(item, iterator);
              // item.electric = iterator.electric;
            }
          }
          // this.list = [...this.list];
          console.log(this.list);
          this.handleList(this.list);
        }
      }
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
    // 大列表点击楼梯是

    handleSelectAllItem(item) {
      this.qvyuList.map((it) => {
        if (it.id == item.stairDeviceNo) {
          this.changeRightMode(it);
        }
      });
    },

    selectPositon(e, row, number) {
      const back = () => {
        this.selectPositonLoading = false;
        this.$message.error('不可选择此方向！');
      };
      if (this.selectPositonLoading) {
        this.$message.warning('请稍后再试！');
        return;
      }
      this.selectPositonLoading = true;
      let index;
      console.log(e, row, number);
      if (!row.arrow_remark || !row.arrow_remark.length) {
        row.arrow_remark = [];
        index = -1;
      } else
        index = row.arrow_remark.findIndex((item) => {
          return item == number;
        });
      // console.log(row.arrow_remark, number, number / 2 > 1, row.arrow_remark.findIndex((item) => item == 1 || 2) != -1);
      if (number / 2 > 1 && row.arrow_remark.findIndex((item) => item == 1 || item == 2) != -1) {
        back();
        return;
      } else if (number / 2 <= 1 && row.arrow_remark.findIndex((item) => item == 3 || item == 4) != -1) {
        back();
        return;
      }
      let arrow_remark = [...row.arrow_remark];
      if (index == -1) arrow_remark.push(number);
      else arrow_remark.splice(index, 1);
      this.$post('/crt/crtArrowLight', { id: row.id, arrow_remark: arrow_remark.join(',') })
        .then(() => {
          row.arrow_remark = arrow_remark;
          this.selectPositonLoading = false;
          this.getdwList();
        })
        .catch((err) => {
          this.selectPositonLoading = false;
        });

      // e.target.style
      var selectList = [];
    },

    // 点位点击时
    pointSelect(e) {
      this.qvyuList.map((it) => {
        if (e.point_uuid == it.point_uuid) {
          this.clearRightStairs();
          this.stairparams.areaUuid = this.rightParams.area_uuid;
          this.stairparams.stairDeviceNo = it.id;
          var obj = {};
          // alert(JSON.stringify())
          this.getRightStairList(it);
          this.tableType = 1;
        }
      });
    },
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },

    setListData(res, columnTable, dataTable) {
      var propArr = [];
      var dataArr = [];
      res.map((item, index) => {
        var dataObj = {};
        var payload = {};
        item.map((it, ind) => {
          if (index == 0) {
            var obj = {}; // 先遍历层数里的东西

            obj.label = it.fireDoorName;
            obj.id = ind;
            obj.floorLabel = '层数';
            obj.other = it;
            propArr.push(obj);
            if (ind == item.length - 1) {
              propArr.unshift({
                label: '层数',
                id: ind + 1,
              });
            }
          }
          dataObj[it.fireDoorName] = it.state;
          dataObj[it.fireDoorName + 'type'] = it.type;
          dataObj['层数'] = String(it.stairsNum);
        });
        dataArr.push(dataObj);
      });

      this[columnTable] = propArr;
      this[dataTable] = dataArr;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.$alert(response.msg, '导入结果', { dangerouslyUseHTMLString: true });
      this.tableType = 0;
      this.getdwList();
      this.getBigList();

      // this.getdwList();
    },
    // 下载上传模板
    downloadstair() {
      this.downLoadExcel('crtarea/exportLightTemplate', { deviceId: '1', areaUUid: this.rightParams.area_uuid }, 'get', (val) => {
        log(val);
      });
    },
    // 列表模式切换
    changeModeType(tp) {
      this.modeType = tp;
      if (tp == 3) {
        this.changeRightMode(0, true);
      }
    },
    changeRightMode(tp, form) {
      if (tp) {
        this.stairparams.areaUuid = this.rightParams.area_uuid;
        this.stairparams.stairDeviceNo = tp.id;
        this.getRightStairList(tp);
      } else {
        this.clearRightStairs();
      }
      this.tableType = tp;
      if (!form) {
        this.changeModeType(1);
      }
    },
    // 设备开关
    handleChange(status) {
      var _this = this;
      this.$confirm(`确认要${status ? '开启' : '关闭'}${this.curObj.true_addr}设备吗？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function() {
          // 设备开启
          _this
            .$put('/mqtt/mqttInfo/switchMQ', {
              deviceNo: _this.curObj.id,
              remark: status,
            })
            .then((res) => {
              this.$message({message: res.msg,type: "success", duration: 700,});
            });
        })
        .catch(function() {});
    },
    // changeFireStatus(isWaring, item) {
    //   this.warning = isWaring;
    //   this.nowMessage = item;

    //   this.startAnimate();
    // },

    // 重置
    resetAnimate() {
      var markers = document.getElementsByClassName('marker');
      for (var j = 0; j < markers.length; j++) {
        if (markers[j].classList.contains('animate')) {
          markers[j].classList.remove('animate');
        }
      }
    },

    startAnimate(detailAddr) {
      if (!this.pointList.length) {
        console.log('无数据');
        return;
      }

      var indx = null;
      var item = null;

      // if (!this.warning) {
      // console.log("取消闪动");
      // return;
      // }

      // if (this.warning) {
      console.log('收到报警 准备闪动 ');
      this.resetAnimate();

      setTimeout(() => {
        for (var i = 0; i < this.pointList.length; i++) {
          if (this.pointList[i].tag === detailAddr) {
            var animateClass = this.pointList[i].point_uuid;
            var markers = document.getElementsByClassName('marker');
            for (var j = 0; j < markers.length; j++) {
              if (markers[j].id === animateClass) {
                markers[j].className += ' animate';
                break;
              }
            }
            console.log('markers循环结束');
            break;
          }
          console.log('pointList 循环结束');
        }
      }, 50);
      // var divs = document.getElementsByClassName('tx-center')
      setTimeout(() => {}, 50);
      // }
    },

    pageChange(val) {
      // console.log(val)
      this.rightParams.page = val;
      this.getdwList();
    },
    reset() {
      this.rightParams.true_addr = '';
      this.getdwList();
    },
    searchRight() {
      this.rightParams.number = this.rightParams.true_addr;
      this.getdwList();
    },

    playVideo() {},

    // 看坐标
    setQuery() {
      var name = this.isdraged ? 'none' : 'block';
      const markers = document.querySelectorAll('.g-image-op');
      for (var i = 0; i < markers.length; i++) {
        markers[i].style.display = name;
      }
    },
    // 搜素单位
    searchcomp() {
      this.companyList1 = [];
      if (!this.company) {
        return;
      }
      if (this.companyList.length) {
        this.companyList.map((item) => {
          if (item.company.indexOf(this.company) > -1) {
            this.companyList1.push(item);
          }
        });
      }
      (this.companyList1.length > 0 ? this.companyList1 : this.companyList)?.forEach((item) => {
        item.data[0] && this.checkCop(item.data[0]);
      });
    },

    //取消标点
    cancle(it) {
      if (this.selectPoint.point_uuid) {
        this.$message.error('请先标记已选择点位！');
        return;
      }
      var obj = {
        point_uuid: it.point_uuid,
        x_axis: '',
        xa_axis: '',
        y_axis: '',
        ya_axis: '',
      };
      this.$post('crt/crtupdatedot', obj).then((res) => {
        console.log(res, '删除');
        // this.$message.success('删除成功');
        this.$message({
									message: '删除成功',
									type: 'success',
									duration: 700,
								});
        this.isdraged = true;
        this.getdwList();
      });
    },
    // 标点
    markp(it, ind, camra) {
      // var data = null
      // this.$refs["lightingPanelEditor"].remove();
      // this.$refs["lightingPanelEditor"].getBiaozhu(this.pointList);
      this.isdraged = false;

      // if (!camra) {
      this.pointList.map((item) => {
        if (item.point_uuid === it.point_uuid) {
          if (this.selectPoint.point_uuid) {
            this.$message.warning('请先标记已选择点位！');
            return;
          }
          this.selectPoint = item;
          this.$refs['lightingPanelEditor'].startBiaoZhu(this.selectPoint);
        }
      });

      this.setQuery();
      // }
      if (camra) {
        this.viewcamra(it, ind);
      }
    },
    // viewcamra(it) {
    //   this.videoAddr = it.true_addr;
    //   this.videoList = [];
    //   console.log(it);
    //   this.$get("/crt/crtInfoByCrtId", { id: it.id }).then((res) => {
    //     console.log(res);
    //     this.curObj = { ...res.data[0], ...it };
    //     console.log(this.curObj);
    //   });
    //   //   this.comara = true;
    //   //   this.getVideoList(it);
    // },
    // 切换列表模式的接口口
    // getBigList() {
    //   this.$get("/device/fireDoorDevice/listAll", {
    //     areaUuid: this.rightParams.area_uuid,
    //   }).then((res) => {
    //     console.log(res);
    //     this.tableData = res.data;
    //     this.setListData(res.data, "detailList", "detaillist");
    //   });
    // },
    // 右侧楼梯小列表接口
    getRightStairList(it) {
      // console.log(JSON.stringify())
      this.startAnimate(it.number);

      this.$get('/device/fireDoorDevice/listByStairsNo', this.stairparams).then((res) => {
        this.detailData = res.data;
        this.setListData(res.data, 'tableList', 'tablelist');
      });
    },
    // setPoint(point) {
    //   this.$refs["aiPanel-editor"].getMarker().renderData(point);
    // },
    // clearPoint(){
    //   this.$refs["aiPanel-editor"].getMarker().clearData();
    // },
    //获取点位
    getdwList() {
      this.clearRightStairs();

      this.$post('/crt/crtEmergencyLight', this.rightParams).then((res) => {
        this.rightNum = res.data.count;
        this.list = res.data.list;
        this.handleList(this.list);
      });
    },
    handleList(list) {
      var companylist = [];
      var pointList = [];
      list.map((item) => {
        var obj1 = {
          number: item.number,
          true_addr: item.device_name,
          point_uuid: item.point_uuid,
          id: item.id,
          state: item.state,
          isMark: item.x_axis ? true : false,
          arrow_remark: item.arrow_remark,
        };
        var obj2 = {
          tag: item.number,
          tagName: ` <div>
                          设备名称:${item.device_name}<br/>
                          部位名称:${item.true_addr}
                       </div>`,
          x: item.x_axis,
          y: item.y_axis,
          type: item.point_type,
          state: item.state,
          point_uuid: item.point_uuid,
          arrow_remark: item.arrow_remark,
        };
        companylist.push(obj1);
        pointList.push(obj2);
      });
      this.qvyuList = companylist;
      this.pointList = pointList;
      // this.qvyuList = res.data.list;
      // this.getPoint();
      this.$refs['lightingPanelEditor'].remove();
      this.$refs['lightingPanelEditor'].getBiaozhu(this.pointList);
      // this.changeFireStatus(this.warning, this.nowMessage);
    },
    // 选择区域的点
    checkCop(it) {
      this.rightParams.area_uuid = it.area_uuid;
      this.rightParams.page = 1;
      this.rightParams.c_number = it.c_number;
      this.dwImg = it.image_name;
      this.tableType = 0;
      this.getdwList();
      // this.getBigList();
    },
    //清除右侧楼梯列表数据
    clearRightStairs() {
      this.stairparams = {
        areaUUid: '',
        stairDeviceNo: '',
      };
      this.tableList = [];
      this.tablelist = [];
      this.detailData = [];
      this.resetAnimate();
    },
    //准备完成时
    ready() {},
    //更新时
    update(v) {
      if (!this.add && this.selectPoint.point_uuid) {
        // 新增的变化
        this.form = {};
        this.form = { ...this.selectPoint, ...v[0] };
      } else {
      }
    },

    added(v) {
      this.selectPoint = {};
      if (v.point_uuid)
        this.$post('/crt/crtupdatedot', v).then((res) => {
          // log(res)
          // this.$message.success('保存成功');
          this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
          this.getdwList();
          // this.draged
          this.isdraged = !this.isdraged;
        });
    },
    //选中标点时
    selected(v) {
      this.isdraged = false;
      this.selectPoint = v;
      this.form = this.selectPoint;
    },
    //滚轮缩小放大
    suo(v) {
      this.num -= -((v.wheelDelta ? v.wheelDelta : v.deltaY) / 1000);
      if (this.num < 0) {
        this.num = 0.1;
      }
    },

    //列表关闭是
    handleClose() {},
    // 列表展开是
    handleOpen() {},
    // 拖拽 目前还未使用
    moveMouse(e) {
      if (this.isdraged) {
        let odiv = this.$refs.can1; //获取目标元素
        //算出鼠标相对元素的位置
        let disX = e.clientX - odiv.offsetLeft;
        let disY = e.clientY - odiv.offsetTop;
        document.onmousemove = (e) => {
          //鼠标按下并移动的事件
          //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          let left = e.clientX - disX;
          let top = e.clientY - disY;

          //绑定元素位置到positionX和positionY上面
          this.positionX = top;
          this.positionY = left;

          //移动当前元素
          odiv.style.left = left + 'px';
          odiv.style.top = top + 'px';
        };
        document.onmouseup = (e) => {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* 设置滚动条宽度和高度 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 8px; /* 横向滚动条 */
  height: 8px; /* 纵向滚动条 必写 */
}
/* 设置滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #dde;
  border-radius: 3px;
}

// 排风机
.controlFire {
  width: 430px;
  .eleButon {
    border: 1px solid #c0c0c0;
    padding: 4px 2px;
    width: 110px;
    border-radius: 15px;
  }

  .eleButonSelect {
    border: 1px solid #78b6ff;
  }

  .closeState {
    display: block;
    margin-top: 2px;
    width: 15px;
    height: 15px;
    background: #f2f2f2;
    box-shadow: 1px 1px #a6a6a6;
    border-radius: 50%;
  }
  .workState {
    background: #399022;
  }
  .stopState {
    background: #d0451b;
  }
  .leftImg {
    width: 280px;
    border: 2px solid #78b6ff;
    padding: 0 10px 10px;
  }
  .rightImg {
    width: 150px;
    border: 2px solid #78b6ff;
    border-left: none;
    padding: 10px;
  }
  .secondControl {
    // height: 90px;
    border: 2px solid #78b6ff;
    border-top: none;
    padding: 10px;

    .btnCont {
      display: flex;
      justify-content: space-around;

      .buttonCont {
        width: 60px;
        cursor: pointer;
        // border: 2px solid #000;
        color: #fff;
        height: 60px;
        // border-radius: 50%;
        display: flex;
        font-size: 16px;
        justify-content: center;
        align-items: center;
        // text-align: cener;
      }
      .disabledOpen {
        opacity: 0.5;
        width: 40px;
        height: 40px;

        font-size: 10px;
        cursor: default;
      }
    }

    .buttonOpen {
      background: repeating-radial-gradient(at center, #a1f1af, #399022);
    }
    .buttonClose {
      background: repeating-radial-gradient(at center, #ffe4d6, 30%, #eb0000);
    }
  }
}

.selectVideo {
  border: solid 2px red;
  height: 500px;
  width: 600px;
  position: relative;
}
::v-deep .selected {
  z-index: 99999;
}
::v-deep .g-image-op {
  background: #fff;
  border: 1px solid #ccc;
  bottom: 110%;
  display: none;
}
::v-deep .g-image-op-del {
  display: none;
}
::v-deep .g-image-op-content {
  height: auto;
}
::v-deep .annotation {
  background: #000;
  border: none;
  /* animation: dianmove 0.5s infinite; */
  border-radius: 50%;
  /* border: none; */
}
::v-deep .animate {
  animation: warningmove 0.6s infinite;
  position: absolute !important;
  /* z-index: 999999; */
}

@keyframes warningmove {
  from {
    background: yellow;
  }
  to {
    background: #ed1c24;
  }
}
.canvas {
  display: flex;
  align-items: center;
}
.container {
  height: 100%;
  max-height: 80vh;
  width: 100%;
  flex-direction: column;
  .topnav {
    height: 20%;
  }
  .leftNav {
    height: 100%;
    max-width: 23%;
  }
  #test {
    height: 100%;
    .el-dialog__body {
      padding: 10px 20px !important;
    }
    .content {
      width: 50%;
      height: 100%;
      background: #000;
      display: flex;
      align-items: center;
      margin: 0 auto;
      overflow: hidden;
      position: relative;
      border: 1px solid gray;
    }
  }
}

.btn {
  padding: 10px;
  width: 80px;
  height: 40px;
  background: #f1f5bb;
  border-radius: 5px;
  margin-left: 10px;
  border: 1px solid #cccccc;
}

.btn-time {
  font-size: 25px;
  font-weight: bold;
}
.show-test {
  // background-color:rgb(40, 210, 52);
  color: #35da08;
}
.light {
  span.show-test {
    animation: EmergencyFlash 1s infinite;
    color: #35da08;
  }
}
.yellow {
  span.show-test {
    color: rgb(235, 181, 60);
  }
}
.gray {
  span.show-test {
    color: rgb(125, 125, 125);
  }
}
@keyframes EmergencyFlash {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
